import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanDeactivate,
  CanActivate
} from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { BodyTypeWarnComponent } from '../common/modals/body-type-warn/body-type-warn.component';
import { ConfirmModalComponent } from '../common/modals/confirm-modal/confirm-modal.component';
import { AuthService } from '../services/auth/auth.service';
import { RatingService } from '../services/rating/rating.service';

@Injectable({
  providedIn: 'root'
})
export class RatingGuard implements CanDeactivate<ConfirmModalComponent> {
  constructor(
    public router: Router,
    private authService: AuthService,
    private ratingService: RatingService,
    private jwtHelper: JwtHelperService,
    public modalService: BsModalService
  ) {}

  canDeactivate(
    component: ConfirmModalComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const ratingSaved: boolean = this.ratingService.ratingSaved.value;
    const overallChecker: boolean = this.ratingService.overallChecker.value;
    const currentUser = this.authService.userData;

    if (!ratingSaved && !this.jwtHelper.isTokenExpired(currentUser.token) && overallChecker) {
      const subject = new Subject<boolean>();
      const modal = this.modalService.show(ConfirmModalComponent, {
        class: 'confirmModal'
      });
      modal.content.saved = subject;
      return subject.asObservable();
    }
    return true;
  }
}

@Injectable({
  providedIn: 'root'
})
export class RatingBodyType implements CanActivate {
  public vinInfo: object = {};

  constructor(public modalService: BsModalService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.vinInfo = JSON.parse(localStorage.getItem('vinInfo')) || {};

    if (!Object.keys(this.vinInfo).length || !this.vinInfo['body_type_id']['id']) {
      const subject = new Subject<boolean>();
      const warnModal = this.modalService.show(BodyTypeWarnComponent, {
        class: 'bodyTypeWarn'
      });

      switch (state.url) {
        case '/vam/rating/exterior':
          if (!Object.keys(this.vinInfo).length)
            warnModal.content.content = 'Please wait for information to load.';
          else if (Object.keys(this.vinInfo).length && !this.vinInfo['body_type_id']['id'])
            warnModal.content.content = 'Please fill up the information form to view ratings.';
          break;
        // case 'commonrating/exterior':
        //   if (!Object.keys(this.vinInfo).length)
        //   warnModal.content.content = 'Please wait for information to load.';
        // else if (Object.keys(this.vinInfo).length && !this.vinInfo['body_type_id']['id'])
        //   warnModal.content.content = 'Please fill up the information form to view ratings.'
        //     // console.log("Vin information is not loaded properly");
        // break;
        case '/vam/estimates':
          if (!Object.keys(this.vinInfo).length)
            warnModal.content.content = 'Please wait for information to load.';
          else if (
            Object.keys(this.vinInfo).length &&
            !this.vinInfo['cod_id']['id'] &&
            !this.vinInfo['cod_id']['value']
          )
            warnModal.content.content = 'Please fill up the information form to access estimates.';
          break;
        case '/report':
          if (!Object.keys(this.vinInfo).length)
            warnModal.content.content = 'Please wait for information to load.';
          else if (
            Object.keys(this.vinInfo).length &&
            !this.vinInfo['cod_id']['id'] &&
            !this.vinInfo['cod_id']['value']
          )
            warnModal.content.content = 'Please fill up the information form to access report.';
          break;
      }

      warnModal.content.saved = subject;
      return subject.asObservable();
    }

    return true;
  }
}

// export interface CanComponentDeactivate {
//   canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
// }
